import { API_BASE } from '../api/client';

export const resolveApiAsset = (source) => {
  const value = String(source || '').trim();
  if (!value || /^(https?:|data:|blob:|\/\/)/i.test(value)) return value;
  const browserOrigin = typeof window === 'undefined' ? '' : window.location.origin;
  let origin = browserOrigin;
  try {
    origin = new URL(API_BASE || '/', browserOrigin).origin;
  } catch { /* Use the current origin for same-origin deployments. */ }
  return `${origin}/${value.replace(/^\/+/, '')}`;
};

export const ASSET_IMAGE_PLACEHOLDER = `data:image/svg+xml;utf8,${encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 240"><rect width="600" height="240" fill="#f3f4f6"/><text x="300" y="125" text-anchor="middle" font-family="Arial" font-size="24" fill="#9ca3af">Image unavailable</text></svg>'
)}`;

export const getAssetImage = (source) => resolveApiAsset(source) || ASSET_IMAGE_PLACEHOLDER;

export const handleAssetImageError = (event) => {
  if (event.currentTarget.getAttribute('src') !== ASSET_IMAGE_PLACEHOLDER) {
    event.currentTarget.src = ASSET_IMAGE_PLACEHOLDER;
  }
};
